var _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimelineReady(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 17,
    stroke: "#B3B3B3",
    strokeWidth: 3
  })));
}

var MemoSvgTimelineReady = /*#__PURE__*/React.memo(SvgTimelineReady);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMzciIHZpZXdCb3g9IjAgMCAzNyAzNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTguNSIgY3k9IjE4LjUiIHI9IjE3IiBzdHJva2U9IiNCM0IzQjMiIHN0cm9rZS13aWR0aD0iMyIvPgo8L3N2Zz4K";
export { MemoSvgTimelineReady as ReactComponent };